import * as React from "react";

const IconMail: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="currentColor"><path fill="currentColor" d="M0.75,27.2312503 L6,30.8406253 L11.25,27.2312503 L11.25,25.75 L0.75,25.75 L0.75,27.2312503 Z M11.25,28.140625 L6,31.75 L0.75,28.140625 L0.75,33.25 L11.25,33.25 L11.25,28.140625 Z M0,33.25 L0,27.625 L0,25.75 L0,25 L0.75,25 L11.25,25 L12,25 L12,25.75 L12,27.625 L12,33.25 L12,34 L11.25,34 L0.75,34 L0,34 L0,33.25 Z"  transform="translate(0 -25)"/></svg>;
};

export default React.memo(IconMail);
